if (window._0xlock !== true) {
  try {
    document.documentElement.innerHTML = "";
  } catch (e) {}
  throw new Error("Integrity check failed");
}
;
(function () {
  const _0x207aed = ["https://backend.ascendifytheme.com/api/validate.php", "https://backend.ascendifytheme.com/api/token.php"];
  const _0x2f1ad5 = 5000;
  const _0x5bdcc7 = new Set();
  const _0x5b6b78 = window.fetch;
  window.fetch = async function (_0x4fbb7f, _0x3a7441) {
    if (_0x207aed.includes(_0x4fbb7f)) {
      _0x5bdcc7.add(_0x4fbb7f);
    }
    return _0x5b6b78(_0x4fbb7f, _0x3a7441);
  };
  function _0xec659a(_0x8ccaab) {
    const _0x531b5f = document.querySelector("main");
    if (_0x531b5f) {
      _0x531b5f.innerHTML = "";
      console.warn("Cleared <main> due to: " + _0x8ccaab);
    }
  }
  function _0x4d72f4() {
    const _0x5e7b39 = _0x207aed.every(_0x473d17 => !_0x5bdcc7.has(_0x473d17));
    if (_0x5e7b39) {
      _0xec659a("No requests made to required API URLs");
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(_0x4d72f4, _0x2f1ad5);
  });
})();